// extracted by mini-css-extract-plugin
var _1 = "GabZi_uq4e";
export { _1 as "root" }
